import { render, staticRenderFns } from "./nuevaCita.vue?vue&type=template&id=cef79c0a&scoped=true"
import script from "./nuevaCita.vue?vue&type=script&lang=js"
export * from "./nuevaCita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef79c0a",
  null
  
)

export default component.exports